import { Artikel } from './../classes/artikel';
import { ModalController, NavParams } from '@ionic/angular';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-filter-popover',
  templateUrl: './filter-popover.page.html',
  styleUrls: ['./filter-popover.page.scss'],
})
export class FilterPopoverPage implements OnInit {
  public nichtVerfuegbareVorhanden: boolean;
  public verfuegbarkeitAlle: boolean;
  public nurTop: boolean;
  public topVorhanden: boolean;
  public artikel: Artikel[] = [];
  public iGroups: string[] = [];
  public groups: string[] = [];
  public iZusaetze: string[] = [];
  public zusaetze: string[] = [];

  constructor(public modalCtrl: ModalController, navParams: NavParams) {
    this.verfuegbarkeitAlle = navParams.get('verfuegbarkeitAlle');
    this.nurTop = navParams.get('nurTopartikel');
    this.topVorhanden = navParams.get('topartikelVorhanden');
    this.nichtVerfuegbareVorhanden = navParams.get('nichtVerfuegbareVorhanden');
    this.artikel = navParams.get('artikel');
    (navParams.get('invisibleGroups') as string[]).forEach(val => this.iGroups.push(val));
    (navParams.get('invisibleZusaetze') as string[]).forEach(val => this.iZusaetze.push(val));
    this.groups = [...new Set(this.artikel.map(item => item.artikelGruppe))];
    this.zusaetze = [...new Set(this.artikel.map(item => item.zusatz))];
  }

  resetFilter() {
    this.nurTop = false;
    this.verfuegbarkeitAlle = true;
    this.iGroups = [];
    this.iZusaetze = [];
  }

  toggleArtikelGruppe(gruppe) {
    const i = this.iGroups.indexOf(gruppe);
    if (i !== -1) {
      this.iGroups.splice(i, 1);
    } else {
      this.iGroups.push(gruppe);
    }
  }


  toggleZusaetze(zusatz) {
    const i = this.iZusaetze.indexOf(zusatz);
    if (i !== -1) {
      this.iZusaetze.splice(i, 1);
    } else {
      this.iZusaetze.push(zusatz);
    }
  }

  setAllInvisible() {
    this.iGroups = [];
    this.groups.forEach(val => this.iGroups.push(val));
  }

  setAllZusaetzeInvisible() {
    this.iZusaetze = [];
    this.zusaetze.forEach(val => this.iZusaetze.push(val));
  }

  ngOnInit() {
  }

  setVerfuegbarkeitAlle(value) {
    this.verfuegbarkeitAlle = value;
  }

  anwenden() {
    this.modalCtrl.dismiss({
      verfuegbarkeitAlle: this.verfuegbarkeitAlle,
      invisibleGroups: this.iGroups,
      invisibleZusaetze: this.iZusaetze,
      nurTopartikel: this.nurTop
    });
  }

  abbrechen() {
    this.modalCtrl.dismiss();
  }
}
